import { API_BASE_URL, CONFIRMATION_TOKEN_KEY, TOKEN_KEY_NEW_PASS } from '../constants';
import { ApiResponse, handleRequest } from '../utils';
import axiosInstance from './axiosInstance';
import axios from 'axios';

export const AuthService = {
  auth: async (email: string, password: string): Promise<ApiResponse<any>> => {
    return handleRequest<any>(async () => {
      return await axiosInstance.post(`${API_BASE_URL}/auth/email/mfa`, {
        email,
        password,
        role: '2fa',
      });
    });
  },
  confirmation: async (code: string): Promise<ApiResponse<any>> => {
    return handleRequest<any>(async () => {
      return await axios.post(
        `${API_BASE_URL}/auth/credentials`,
        {
          code,
          role: '2fa',
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem(CONFIRMATION_TOKEN_KEY)}`,
          },
        },
      );
    });
  },
  requestResetPassword: async (email: string, code?: string): Promise<ApiResponse<any>> => {
    return handleRequest<any>(async () => {
      return await axiosInstance.post(`${API_BASE_URL}/auth/password/reset`, {
        email,
        otc: code,
        role: '2fa',
      });
    });
  },
  resetPassword: async (password: string): Promise<ApiResponse<any>> => {
    return handleRequest<any>(async () => {
      return axios.post(
        `${API_BASE_URL}/auth/password`,
        {
          password,
          role: '2fa',
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem(TOKEN_KEY_NEW_PASS)}`,
          },
        },
      );
    });
  },
};
